import React from "react";
import InfoContent from "./InfoContent";
import CollapseContent from "./CollapseContent";
interface ContentProfileProps {
  data: any;
  role: string;
}
const BeneficiaryProfile = ({ data }: ContentProfileProps) => {
  const benificiaryTabs = [
    { label: "أفراد الأسرة", number: data?.person_ids?.length },
    { label: "العائل الرئيسي" },
    { label: "سكن الأسرة" },
    { label: "ممتلكات الأسرة", number: data?.housing_type_ids?.length },
    { label: "مصادر الدخل", number: data?.material_state_ids?.length },
    { label: "الإلتزامات الجارية", number: data?.liability_ids?.length },
  ];
  return (
    <div className="takaful--content-profile">
      <div className="takaful--content-profile-info">
        <div className="takaful--content-profile-title">
          <h1 style={{ marginBottom: "4rem" }}> المعلومات الأساسية للأسرة</h1>
        </div>
        <InfoContent infoArray={data} />
      </div>
      <div className="takaful--content-edit-profile-info">
        <CollapseContent tabsData={benificiaryTabs} CollapseArray={data} />
      </div>
    </div>
  );
};

export default BeneficiaryProfile;
